import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin } from "lucide-react";
import { CONTACT, LOGO_URL, BOOKING_URL } from "../mock/mock";

export default function Footer() {
  return (
    <footer className="bg-forge-navy text-white/80">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Forge Stays" className="h-14 w-14 rounded-full object-cover" />
            <div>
              <div className="font-serif text-2xl text-white">Forge Stays</div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-forge-gold">Escape . Unwind . Return</div>
            </div>
          </div>
          <p className="mt-5 text-white/70 text-sm max-w-md leading-relaxed">
            Comfortable Anglesey stays — five entire three-bedroom en-suite townhouses on Cymyran
            Terrace and a Newry Street townhouse in Holyhead, all bookable now. A nine-bedroom
            Lodge at Hotel Cymyran and boutique hotel rooms to follow.
          </p>
        </div>

        <div>
          <div className="text-forge-gold text-xs tracking-[0.28em] uppercase mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-forge-gold">Home</Link></li>
            <li><a href="/#about" className="hover:text-forge-gold">About</a></li>
            <li><a href="/#audiences" className="hover:text-forge-gold">Who We Welcome</a></li>
            <li><a href="/#accommodation" className="hover:text-forge-gold">Accommodation</a></li>
            <li><Link to="/gallery" className="hover:text-forge-gold">Gallery</Link></li>
            <li><a href="/#contact" className="hover:text-forge-gold">Contact</a></li>
          </ul>
        </div>

        <div>
          <div className="text-forge-gold text-xs tracking-[0.28em] uppercase mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Mail size={14} className="mt-1" /><a href={`mailto:${CONTACT.email}`} className="hover:text-forge-gold break-all">{CONTACT.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-1" /><span>{CONTACT.address_line2}, {CONTACT.address_line3}</span></li>
          </ul>
          <div className="mt-5 flex items-center gap-3">
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:border-forge-gold hover:text-forge-gold transition"><Instagram size={16} /></a>
            <a href={CONTACT.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:border-forge-gold hover:text-forge-gold transition"><Facebook size={16} /></a>
          </div>
          <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-gold mt-6 inline-flex">Book Now</a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 text-xs text-white/50 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>&copy; {new Date().getFullYear()} Forge Stays. All rights reserved.</div>
          <div>Escape . Unwind . Return</div>
        </div>
      </div>
    </footer>
  );
}
